import { MessageTypes, WHEN } from "../constants/ActionTypes";
import * as api from "./../api/index";

const GetMessages = () => async (dispatch) =>
{
  try
  {
    const data = await api.fetchMessages();
    console.log(data);
    dispatch({ payload: data, type: MessageTypes.FETCH_ALL });
  }
  catch (err)
  {
    console.trace(err);
  }
}

const AddMessage = (messageData) => async (dispatch) =>
{
  try
  {
    await api.addMessage(messageData);

    dispatch({ payload: messageData.body, type: MessageTypes.POST_MESSAGE });
  }
  catch (err)
  {
    console.trace(err);
  }
}

const RenderNewMessage = (msg) => async (dispatch) =>
{
  try
  {
    switch (msg.headers)
    {
      case WHEN.FIRST:
        dispatch({ payload: msg.body, type: MessageTypes.FETCH_ALL });
        break;
      case WHEN.NORMAL:
        dispatch({ payload: msg.body, type: MessageTypes.NEW_MESSAGE });
        break;
      default:
        console.log("(´。＿。｀) that wasn't supposed to happen");
        break;
    }
  }
  catch (err)
  {
    console.trace(err);
  }
}



export { GetMessages, AddMessage, RenderNewMessage };

